<template>
  <b-card
    no-body
    class="mb-2 shadow-sm border-0 ai-card trend-card"
    :class="trendBorderClass"
    role="button"
    tabindex="0"
    :aria-label="ariaLabel"
    @click="onActivate"
    @keydown.enter.prevent="onActivate"
    @keydown.space.prevent="onActivate"
  >
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-2">
        <b-icon-graph-up
          class="mr-2"
          :class="trend.direction === 'down' ? 'text-danger' : 'text-success'"
          font-scale="1.2"
          aria-hidden="true"
        />
        <h6 class="m-0 font-weight-bold text-uppercase" style="font-size: 13px;">Trend forecast</h6>
        <b-icon-info-circle class="ml-auto text-muted" v-b-tooltip.hover.html="tooltipHtml" />
      </div>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="small">
          <div>{{ trend.currentYear }}: <strong>{{ trend.currentValue }}</strong></div>
          <div class="text-muted">{{ trend.nextYear }} (proj.): <strong>{{ trend.projectedValue }}</strong></div>
        </div>
        <div aria-hidden="true">
          <b-icon-arrow-up-right v-if="trend.direction === 'up'" variant="success" font-scale="1.5" />
          <b-icon-arrow-down-right v-else-if="trend.direction === 'down'" variant="danger" font-scale="1.5" />
          <b-icon-arrow-right v-else variant="secondary" font-scale="1.5" />
        </div>
      </div>
      <p class="small text-muted mb-1">
        Confidence: <strong>{{ trend.confidence | capitalize }}</strong>
        <span v-if="trend.yearsUsed"> ({{ trend.yearsUsed }} yrs)</span>
      </p>
      <div class="text-right">
        <b-button
          size="sm"
          :variant="trend.direction === 'down' ? 'outline-danger' : 'outline-success'"
          class="mt-2"
          aria-label="Overlay simple linear forecast on time series charts"
          @click.stop="onActivate"
        >
          Overlay trend
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'TrendCard',
  props: {
    trend: {
      type: Object,
      required: true,
    },
    explanation: {
      type: String,
      default: '',
    },
    whyMatters: {
      type: String,
      default: '',
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      const s = value.toString();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
  },
  computed: {
    trendBorderClass() {
      if (this.trend.direction === 'down') return 'trend-card--down';
      if (this.trend.direction === 'up') return 'trend-card--up';
      return 'trend-card--flat';
    },
    tooltipHtml() {
      const w = this.whyMatters ? `<div class="mt-1"><em>Why this matters:</em> ${this.whyMatters}</div>` : '';
      return `${this.explanation || ''}${w}`;
    },
    ariaLabel() {
      return `Trend forecast from ${this.trend.currentYear} to projected ${this.trend.nextYear}. Press Enter to overlay on charts.`;
    },
  },
  methods: {
    onActivate() {
      this.$emit('overlay-trend', this.trend);
    },
  },
};
</script>

<style scoped>
.ai-card {
  cursor: pointer;
}
.trend-card--up {
  border-left: 4px solid #28a745 !important;
}
.trend-card--down {
  border-left: 4px solid #dc3545 !important;
}
.trend-card--flat {
  border-left: 4px solid #6c757d !important;
}
</style>
